import 'element-plus/dist/index.css';
import './styles/global.less';
import { createApp as createCSRApp, createSSRApp } from 'vue';
import { ID_INJECTION_KEY } from 'element-plus';
import createI18n from '@/locales';
import createStore from '@/store';
import createRouter from '@/router';
import { LogReporter } from '@/common/log-report';
import ARMS from '@/common/arms';
import Expose from '@/directives/expose';
import App from './App.vue';

export function createApp() {
  const app = import.meta.env.SSR ? createSSRApp(App) : createCSRApp(App);

  const i18n = createI18n();
  const store = createStore();
  const router = createRouter();

  app
    .use(i18n)
    .use(store)
    .use(router)
    .directive('expose', Expose)
    .provide(ID_INJECTION_KEY, {
      prefix: Math.floor(Math.random() * 10000),
      current: 0,
    });


  if (!import.meta.env.SSR) {
    LogReporter.init();
    ARMS.init(app);
  }

  return { app, i18n, store, router };
}